import TopBar from "./components/topbar/TopBar";
import Inicio from "./pages/inicio/Inicio";
import RopaMain from "./pages/CategoriesSubcategories";
import Contacto from "./pages/contacto/Contacto";
import React, { useContext } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { GlobalContext } from './GlobalContext';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import icon_loading from "./images/iconosinicio/icono_percha.png";

function App() {
  const { data } = useContext(GlobalContext);

  if (!data) {
    return (
      <div style={styles.spinnerContainer}>
        {/* Spinner Container for centering both spinner and icon */}
        <div style={styles.spinnerWrapper}>
          {/* Loading Spinner */}
          <ClipLoader size={200} color={"#123abc"} loading={true} />
          
          {/* Image to be displayed inside the spinner */}
          <img src={icon_loading} alt="Loading" style={styles.loadingImage} />
        </div>
        
        {/* Text below the spinner */}
        <p style={styles.loadingText}>Cargando...</p>
      </div>
    );
  }

  const renderRoute = (path, key) => (
    <Route
      key={key}
      path={path}
      element={
        data[key] ? (
          <RopaMain BackendData={data[key]} />
        ) : (
          <div style={styles.spinnerContainer}>
            <div style={styles.spinnerWrapper}>
              {/* Loading Spinner */}
              <ClipLoader size={200} color={"#123abc"} loading={true} />
              {/* Image to be displayed inside the spinner */}
              <img src={icon_loading} alt="Loading" style={styles.loadingImage} />
            </div>
            <p style={styles.loadingText}>Cargando...</p>
          </div>
        )
      }
    />
  );

  return (
    <>
      <Router>
        <TopBar />
        <Routes>
          <Route path="/" element={<Inicio />} />
          {renderRoute("/ropamujer", "ropaMujer")}
          {renderRoute("/ropahombre", "ropaHombre")}
          {renderRoute("/calzado", "calzado")}
          {renderRoute("/ropainteriorypijamas", "ropainteriorypijamas")}
          {renderRoute("/banadoresybikinis", "banadoresybikinis")}
          {renderRoute("/bolsosycomplementos", "bolsosycomplementos")}
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </Router>
      <Analytics />
      <div>
        <SpeedInsights />
      </div>
    </>
  );
}

const styles = {
  spinnerContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh', // Ensures the container takes the full height of the screen
    flexDirection: 'column', // Stack spinner, image, and text vertically
  },
  spinnerWrapper: {
    display: 'flex',
    justifyContent: 'center', // Horizontally center the spinner and the image
    alignItems: 'center', // Vertically center the spinner and the image
    flexDirection: 'column', // Stack spinner and image vertically
    position: 'relative',
  },
  loadingImage: {
    position: 'absolute', // Make sure the image is centered inside the spinner
    width: '90px', // Adjust the image size as needed
    height: 'auto',
  },
  loadingText: {
    marginTop: '20px', // Space between the spinner (with the image inside) and the text
    fontSize: '20px',
    color: 'black',
    textAlign: 'center',
    fontWeight: 'bold',
  },
};

export default App;
